import useRouteTheme from "../hooks/useRouteTheme";

export default function RouteThemeGate() {
  useRouteTheme();
  return null;
}
